<template>
  <v-app>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>

</script>

<style></style>
